import {
	refinementList,
	panel,
	dynamicWidgets,
} from 'instantsearch.js/es/widgets';
import {
	facetHeaderTemplate,
	facetBodyTemplate,
} from '../templates/facetsTemplate';

// TODO: Determine if using 'id' would be better to target HTML elements rather than class names for the algolia widgets
const facetsContainer = document.querySelector(
	'.algolia-search-list-page__facets',
);

const createRefinementListWidget = attribute => {
	return container =>
		panel({
			hidden(options) {
				return options.length === 0 || options.items.length === 0;
			},
			collapsed: () => false,
			templates: {
				header(options, { html }) {
					return facetHeaderTemplate(html, options.widgetParams.attribute);
				},
			},
		})(refinementList)({
			container,
			attribute,
			limit: facetsContainer?.dataset.facetsShowLessLimit || 5,
			showMore: true,
			showMoreLimit: facetsContainer?.dataset.facetsShowMoreLimit || 100,
			templates: {
				item(item, { html }) {
					return facetBodyTemplate(item, html, attribute);
				},
				showMoreText(data) {
					return `${
						data.isShowingMore
							? facetsContainer?.dataset?.showLessText
							: facetsContainer?.dataset?.showMoreText
					}`;
				},
			},
			cssClasses: {
				root: 'ais-RefinementList--collapsed',
			},
		});
};

// Flag to ensure widgets are only added once and to avoid infinite loop
let facetWidgetsAdded = false;

// Function to add facet widgets dynamically
const addFacetWidgets = (facetNames, algoliaSearch) => {
	const widgets = facetNames.map(createRefinementListWidget);
	algoliaSearch.addWidgets([
		dynamicWidgets({
			container: facetsContainer,
			widgets,
		}),
	]);
};

const attachShowMoreListener = () => {
	document
		.querySelectorAll('.ais-RefinementList')
		.forEach(refinementListContainer => {
			const showMoreButton = refinementListContainer.querySelector(
				'.ais-RefinementList-showMore',
			);

			if (showMoreButton && !showMoreButton.dataset.listenerAttached) {
				showMoreButton.addEventListener('click', () => {
					refinementListContainer.classList.toggle(
						'ais-RefinementList--expanded',
					);
					refinementListContainer.classList.toggle(
						'ais-RefinementList--collapsed',
					);
				});
				// To Avoid Duplicating Listeners
				showMoreButton.dataset.listenerAttached = 'true';
			}
		});
};

const initFacets = algoliaSearch => {
	algoliaSearch.on('render', () => {
		// eslint-disable-next-line no-underscore-dangle
		const facetList = algoliaSearch.helper?.lastResults?._rawResults[0].facets;
		if (!facetWidgetsAdded && facetList) {
			const facetNames = Object.keys(facetList);
			addFacetWidgets(facetNames, algoliaSearch);
			facetWidgetsAdded = true;
		} else if (facetWidgetsAdded) {
			attachShowMoreListener();
		}
	});
};

export default initFacets;
